export default __webpack_public_path__ + "static/char-11-anr-ab58b58676fc917c3cd038e55f1f6871.webp";